import { useMemo } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { Requirement, Select } from "../../types/requirement.response";
import { getAllCourseOptionsForRequirement } from "../../utils/requirementResponseUtils";
import ChecklistCourseSetSlots from "./ChecklistCourseSetSlots";
import ChecklistEmptySlot from "./ChecklistEmptySlot";

interface ChecklistGroupSlotsProps {
    rootNode: Select;
    requirement: Requirement;
    coursesMap: Record<string, CourseSummary>;
    onAdd: (course: AddableCourse, nodeId: string | null) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
}

export default function ChecklistGroupSlots({ rootNode, requirement, coursesMap, onAdd, onDelete }: ChecklistGroupSlotsProps) {
    const isFulfilled = rootNode.summary.isFulfilled;

    const allCourses = useMemo(
        () => getAllCourseOptionsForRequirement(requirement, coursesMap),
        [requirement, coursesMap]
    );

    return (
        <div className="flex flex-col gap-3">
            {rootNode.children.map((child) => {
                if (child.type !== "COURSE_SET") return null;
                return (
                    <ChecklistCourseSetSlots
                        key={child.id}
                        courseSet={child}
                        coursesMap={coursesMap}
                        requirementId={requirement.info.id}
                        onAdd={(course) => onAdd(course, child.id)}
                        onDelete={onDelete}
                        idPrefix="checklist-group"
                        label={child.title ?? undefined}
                    />
                );
            })}
            {isFulfilled && (
                <ChecklistEmptySlot
                    allCourses={allCourses}
                    onAdd={(course) => onAdd(course, null)}
                    nodeId={null}
                    dropId={`checklist-group-slot-${requirement.info.id}-extra`}
                    compact
                />
            )}
        </div>
    );
}
